import { render, staticRenderFns } from "./setInvited.vue?vue&type=template&id=68e24241&scoped=true&"
import script from "./setInvited.vue?vue&type=script&lang=js&"
export * from "./setInvited.vue?vue&type=script&lang=js&"
import style0 from "./setInvited.vue?vue&type=style&index=0&id=68e24241&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e24241",
  null
  
)

export default component.exports